import { t } from '../locale';

export default {
    methods: {
        t(...args) {
            return t.apply(this, args);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/mixin/locale.js